var SCAAFFCustomerReferSetting = {
    "program": {
        "active": true,
        "shop": "biaskin.myshopify.com",
        "incentive": {
            "type": "percentage",
            "value": "10.00",
            "price_rule_id": 1055619285163,
            "coupon": "UPPROMOTE_CUSTOMER_REFERRAL"
        },
        "program": "ODA1NTc="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "REFER & EARN",
            "refer_background_color": "#dc9f8e",
            "refer_text_color": "#ffffff",
            "web_position": "right-bottom",
            "mobile_position": "right-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "Refer & Get 10% from friend's orders",
            "popup_description": "Send your friends a 10.00% discount off their purchase. Once they make a purchase, you'll earn 10% for each order as well! This reward can be redeemed for coupons.",
            "button_text_get_invite": "Get invite link",
            "button_copy_invite": "Copy invite link",
            "popup_background_color": "#dc9f8e",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "SURPRISE! You got 10% Off",
            "shop_description": "Congrats! Your friend has gifted you a coupon. Coupon will be automatically applied at the checkout page.",
            "shop_button_text": "Shop Now",
            "shop_background_color": "#dc9f8e",
            "shop_text_color": "#ffffff"
        }
    }
}